import React from 'react'
import {useState, useEffect, useCallback} from 'react'
import { QueueListIcon } from '@heroicons/react/24/outline';
import { debounce } from 'lodash';

import {
    Input
} from "@material-tailwind/react";

import { v4 as uuidv4 } from 'uuid';
import { mintCheck } from '../util/api';
import { useNavigate } from 'react-router-dom';
import data from '../assets/metadata.json';
import logo from '../assets/imgs/logo.webp';
import { useLocation } from 'react-router-dom';


export default function Header(props) {
  const navigate = useNavigate();
  const location = useLocation();

  const getCurrentRoute = () => {
    return location.pathname.split('/')[1] || '';
  }

  const currentRoute = getCurrentRoute();

  const { openRightMenu, deployCount } = props;

  return (
    <div className={`md:h-[80px] h-[50px] z-[9999] flex flex-row justify-between items-center w-full ${location.pathname === '/news' || location.pathname === '/disclaimer' ? 'bg-background' : ''}`}>
      <div className="md:flex hidden flex-row justify-between items-center w-full mt-1">
        <div className="flex flex-row gap-2 ml-3">
          {
            location.pathname === '/' ?
            <></>:
            <img src={logo} alt="logo" className="h-[60px] cursor-pointer" onClick={() => navigate('/')}/>
          }
        </div>
        <div className="flex flex-row gap-8 mr-4">
          <div className={`hover:text-red-800 font-bold text-2xl mt-1 cursor-pointer ${currentRoute === 'about' ? 'text-red-800' : 'text-white'}`} onClick={() => navigate('/about')}>ABOUT</div>
          <div className={`hover:text-red-800 font-bold text-2xl mt-1 cursor-pointer ${currentRoute === 'news' ? 'text-red-800' : 'text-white'}`} onClick={() => navigate('/news')}>NEWS</div>
          {/* <div className="font-bold text-white text-2xl mt-1 cursor-pointer" >GALLERY</div>
          <div className="font-bold text-white text-2xl mt-1 cursor-pointer" >NEWS</div> */}
          <div className="flex flex-col">
            <div className="font-bold text-white text-2xl bg-red-800 px-2 py-1 rounded-md text-center cursor-pointer" onClick={() => navigate('/')}>MINT</div>
            <div className="text-white text-sm bg-red-800 rounded-md mt-1 px-2">{deployCount}/21000</div>
          </div>
        </div>
      </div>
      <div
        className="md:hidden flex flex-row w-full justify-end text-red-800 mr-2 cursor-pointer"
        onClick={openRightMenu}
      >
        <QueueListIcon strokeWidth={2} className="h-8 w-8" />
      </div>
    </div>
  )
}
